var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echart",staticClass:"chart-wrap",staticStyle:{"width":"100%","height":"300px"},style:(_vm.id==='chart2'?'height:260px':''),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }